import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import PostFeed from 'containers/Post/Feeds/PostFeed';
import PendingApproval from 'containers/Member/PendingApproval';
import { authSelectors } from 'redux/auth';

// The feed widget's config is for the feed alone, so none of it reaches the pending screen
const HomeFeed = ({ pulse, pulseMin, pulseStart, pulseMax, pulseRepeat, ...args }) => {

  const pending = useSelector(authSelectors.isPendingMember);

  return pending
    ? <PendingApproval {...args} />
    : <PostFeed feedType="home" pulse={pulse} pulseMin={pulseMin} pulseStart={pulseStart} pulseMax={pulseMax} pulseRepeat={pulseRepeat} {...args} />;
};

HomeFeed.propTypes = {
  pulse: PropTypes.bool,
  pulseMin: PropTypes.number,
  pulseStart: PropTypes.number,
  pulseMax: PropTypes.number,
  pulseRepeat: PropTypes.number,
};

export default HomeFeed;
